/** The school's one email domain. The server decides it (a deployment sets
 * SCHOOL_EMAIL_DOMAIN) and returns it with each username suggestion; this is
 * what a screen shows when it has no answer from the server to go on. */
export const DEFAULT_SCHOOL_EMAIL_DOMAIN = "tpss.com";

/** The address that belongs to a login: jnakato -> jnakato@tpss.com.
 *
 * Every account on the system is reached this way -- staff, learners and
 * parents alike -- so no address is ever typed in and none can drift from
 * the login it belongs to. The server works the same address out as an
 * account is created; this is only so a screen can show it while it is
 * being filled in.
 */
export function schoolEmail(
  username: string,
  domain: string = DEFAULT_SCHOOL_EMAIL_DOMAIN,
) {
  const login = username.trim().toLowerCase();
  return login ? `${login}@${domain}` : "";
}
